// extracted by mini-css-extract-plugin
module.exports = {"checkField":"CheckBox_checkField__3cz8O","checkFieldInput":"CheckBox_checkFieldInput__3yBP9","checkFieldLabel":"CheckBox_checkFieldLabel__2hP2p"};